module.exports = __webpack_public_path__ + "static/img/x-close.358a09db.svg";